/* global UUID */
import { useQuery } from '@zenbusiness/application-commons-graphql';
import { validate } from 'uuid';

import { FORMATION_TIMELINE_V2_QUERY } from '../pages/Home/constants/queries';

const hasFormationTimeline = (orderTasks) => {
  const timelineTaskTypes = [
    'llc_formation',
    'corp_formation'
  ];
  const canceledFormationStatus = [
    'canceled',
    'cancelled'
  ];
  /*
  free dash, reserved name, canceled entities
  and entities created before middle of 2021
  will not produce a timeline
  */
  const canGenerateTimeline = orderTasks
    .find((tasks) => timelineTaskTypes.includes(tasks.orderTaskType)
      && !canceledFormationStatus.includes(tasks.orderTaskStatus)
      && tasks.orderTaskStatusUpdates.length > 0); // older entities will not have a history

  return !!canGenerateTimeline;
};

/**
 * Hook to use Formation Timeline GraphQL Query
 *
 * @param {UUID} businessEntityUuid
 * @param {Array} orderTasks
 * @returns {{ loading, error, data }}
 */
const useFormationTimelineQuery = (businessEntityUuid, orderTasks = []) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const { loading, error, data } = useQuery(
    FORMATION_TIMELINE_V2_QUERY,
    {
      skip: !businessEntityUuid
        || !validate(businessEntityUuid)
        || !hasFormationTimeline(orderTasks),
      variables: {
        businessEntityUuid,
        timezone
      },
      noThrow: true
    }
  );

  return { loading, error, data: data?.formationTimelineV2 };
};

export default useFormationTimelineQuery;
